import { atomFamily } from "recoil";

import { IFilterSchemaObject, RydeUiUnit } from "../../models";

export const tableFiltersSchemaAtomFamily = atomFamily<
  IFilterSchemaObject | undefined,
  RydeUiUnit
>({
  key: "tableFiltersSchemaAtomFamily",
  default: undefined,
});
